export const RECEIVE_ACTIVE_COURSES = 'RECEIVE_ACTIVE_COURSES';
export const SORT_ACTIVE_COURSES = 'SORT_ACTIVE_COURSES';
export const RECEIVE_CAMPAIGN_ACTIVE_COURSES = 'RECEIVE_CAMPAIGN_ACTIVE_COURSES';
